import React, { useState } from "react";
import PropTypes from "prop-types";

export default function StatsComponent({ data }) {
  const [visible, setVisible] = useState(true);

  const entries =
    data instanceof Map ? Array.from(data.entries()) : Object.entries(data);

  const handleToggle = () => setVisible((prev) => !prev);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md p-4">
      <button
        onClick={handleToggle}
        className="mb-4 px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
      >
        {visible ? "Hide Stats" : "Show Stats"}
      </button>

      {visible && (
        <div className="p-4 border rounded-lg shadow-sm bg-white">
          <ul className="space-y-2">
            {entries.map(([key, value]) => (
              <li key={key} className="flex justify-between">
                <span className="font-semibold">{key}</span>
                <span>{value}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

StatsComponent.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.instanceOf(Map),
    PropTypes.objectOf(PropTypes.string),
  ]).isRequired,
};
